import { publicClient, privateClient } from "../../configs/axiosConfig";

const serviceEndpoints = {
  getallNail: "v2/nails",
  getNailDetail: "v2/nails/:id",
  updateNailsService: "v2/nails/update-store",
  getallBeauty: "v2/beauty",
  getBeautyDetail: "v2/beauty/:id",
  updateBeautyService: "v2/beauty/update-store",
};

const sericesApi = {
  getallNail: async ({ operatorId }) => {
    try {
      const response = await privateClient.get(
        `${serviceEndpoints.getallNail}?operatorId=${operatorId}`
      );

      return { response };
    } catch (err) {
      console.log("err to get all nail");
      return { err };
    }
  },
  getNailDetail: async ({ nailId }) => {
    try {
      const response = await privateClient.get(serviceEndpoints.getNailDetail, {
        nailId,
      });

      return { response };
    } catch (err) {
      console.log("err to get all nail");
      return { err };
    }
  },
  updateNailsService: async (payload) => {
    try {
      const response = await privateClient.patch(
        serviceEndpoints.updateNailsService,
        payload
      );
      return { response };
    } catch (err) {
      console.error("Failed to update service stores", err);
      return { err };
    }
  },
  getallBeauty: async ({ operatorId }) => {
    try {
      const response = await privateClient.get(
        `${serviceEndpoints.getallBeauty}?operatorId=${operatorId}`
      );

      return { response };
    } catch (err) {
      console.log("err to get all nail");
      return { err };
    }
  },
  getBeautyDetail: async ({ beatyId }) => {
    try {
      const response = await privateClient.get(
        serviceEndpoints.getBeautyDetail,
        {
          beatyId,
        }
      );

      return { response };
    } catch (err) {
      console.log("err to get all nail");
      return { err };
    }
  },
  updateBeautyService: async (payload) => {
    try {
      const response = await privateClient.patch(
        serviceEndpoints.updateBeautyService,
        payload
      );
      return { response };
    } catch (err) {
      console.error("Failed to update service stores", err);
      return { err };
    }
  },
};

export default sericesApi;
